import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { put } from '../utils/networking';
import { mapI18nLanguageToApiLanguage } from './queries/language.mapper';

export const saveUserLanguage = (language: string) => put('/api/users/me/language', { language });

/**
 * Keeps the language the user chose in the app on the server, so emails to them use it too.
 * Saved once when the app opens and again each time the user changes it.
 */
export const useSaveUserLanguage = () => {
  const { i18n } = useTranslation();
  const saved = useRef<string | null>(null);
  const language = mapI18nLanguageToApiLanguage(i18n.language ?? 'no');

  useEffect(() => {
    if (saved.current === language) return;
    saved.current = language;
    saveUserLanguage(language).catch(() => {
      // Emails fall back to the organisation's language, so try again next time
      saved.current = null;
    });
  }, [language]);
};
